/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import ClazzCourseVo from '../../clazz_course/model/ClazzCourseVo';
import CourseStatisticsVo from '../../clazz_course/model/CourseStatisticsVo';
import PagingAccountProgressVo from '../../clazz_course/model/PagingAccountProgressVo';
import PagingClazzCourseVo from '../../clazz_course/model/PagingClazzCourseVo';
import TextbookStatisticsVo from '../../clazz_course/model/TextbookStatisticsVo';
  /**
   * ClazzCourse service.
   * @module clazz_course/api/ClazzCourseApi
   * @version 0.2.0
   */

  /**
   * Constructs a new ClazzCourseApi. 
   * @alias module:clazz_course/api/ClazzCourseApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 班课分页列表
     * @param {Integer} pageNum 页码
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.companyId 学校id
     * @param {Integer} opts.courseStandardId 课程标准id
     * @param {Integer} opts.schoolTermId 学期id
     * @param {Integer} opts.teacherAccountId 教师id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:clazz_course/model/PagingClazzCourseVo}
     */
this.findPagingClazzCourse = function(pageNum, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPagingClazzCourse";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum,
        'companyId': opts['companyId'],
        'courseStandardId': opts['courseStandardId'],
        'schoolTermId': opts['schoolTermId'],
        'teacherAccountId': opts['teacherAccountId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingClazzCourseVo;
      return this.apiClient.callApi(
        '/api/clazz_course/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 班课统计
     * @param {Integer} id 班课id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:clazz_course/model/CourseStatisticsVo}
     */
this.getCourseStatistics = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getCourseStatistics";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CourseStatisticsVo;
      return this.apiClient.callApi(
        '/api/clazz_course/{id}/course_statistics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取班课信息
     * @param {Integer} id 班课id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:clazz_course/model/ClazzCourseVo}
     */
this.getDetail = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getDetail";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = ClazzCourseVo;
      return this.apiClient.callApi(
        '/api/clazz_course/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 班课中各项目学员排名
     * @param {Integer} id 班课id
     * @param {String} indicator 排名类别（studyProgress学习进度、studyDuration学习总时长、readingDuration阅读时长、videoDuration视频时长、exercisesAccuracy测试平均正确率、exercisesNum交互练习次数、notesNum笔记条数、hightlightNum高亮条数、maxContinuedTime最长连续学习时长、extendedStudyNum扩展学习次数、threadInitiatedNum发起讨论次数、threadJoinedNum参与讨论次数）
     * @param {Integer} pageNum 页码
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.textbookId 教材id
     * @param {Integer} opts.unitId 单元id
     * @param {Integer} opts.lessonId 节id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:clazz_course/model/PagingAccountProgressVo}
     */
this.getStudentsRanking = function(id, indicator, pageNum, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getStudentsRanking";
      }

      // verify the required parameter 'indicator' is set
      if (indicator == undefined || indicator == null) {
        throw "Missing the required parameter 'indicator' when calling getStudentsRanking";
      }

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling getStudentsRanking";
      }


      var pathParams = {
        'id': id,
        'indicator': indicator
      };
      var queryParams = {
        'pageNum': pageNum,
        'textbookId': opts['textbookId'],
        'unitId': opts['unitId'],
        'lessonId': opts['lessonId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingAccountProgressVo;
      return this.apiClient.callApi(
        '/api/clazz_course/{id}/{indicator}/students_ranking', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 班课教材使用统计
     * @param {Integer} id 班课id
     * @param {Integer} textbookId 教材id
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.unitId 单元id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:clazz_course/model/TextbookStatisticsVo}
     */
this.getTextbookStatistics = function(id, textbookId, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getTextbookStatistics";
      }

      // verify the required parameter 'textbookId' is set
      if (textbookId == undefined || textbookId == null) {
        throw "Missing the required parameter 'textbookId' when calling getTextbookStatistics";
      }


      var pathParams = {
        'id': id,
        'textbookId': textbookId
      };
      var queryParams = {
        'unitId': opts['unitId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookStatisticsVo;
      return this.apiClient.callApi(
        '/api/clazz_course/{id}/{textbookId}/statistics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
